import script from "./TumorBoardNewSession.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoardNewSession.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoardNewSession.vue?vue&type=style&index=0&id=0a736f40&lang=css"

const __exports__ = script;

export default __exports__